/**
 * 解析所有模块下国际化资源文件装配到主资源文件中
 * @type {Null}
 */
import language from '@src/common/config/language'
const context = require.context('@src/modules', true, /\/lang\/.*\.js$/);
let modulesLanguage = {};
const langKeys = [];
for (let key in language.LANGUAGE_MAP) {
  langKeys.push(language.LANGUAGE_MAP[key].localI18n);
}
context.keys().forEach(key => {
  const tempKey = key.split('/');
  const langKey = tempKey[tempKey.length - 1].split('.js')[0];
  if (langKeys.indexOf(langKey) !== -1) {
    if (!modulesLanguage[langKey]) {
      modulesLanguage[langKey] = {};
    }
    modulesLanguage[langKey] = { ...modulesLanguage[langKey], ...context(key).default }
  }
});
export default modulesLanguage